import { render, staticRenderFns } from "./riqinggly.vue?vue&type=template&id=9496932c"
import script from "./riqinggly.vue?vue&type=script&lang=js"
export * from "./riqinggly.vue?vue&type=script&lang=js"
import style1 from "./riqinggly.vue?vue&type=style&index=1&id=9496932c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports